$(function () {
  // pc端回到顶部
  $(".pcTop #gotoTop").hide(); //隐藏go to top按钮
  $(window).scroll(function () {
    var scrollHeight = $(document).height() * 0.02;
    if ($(this).scrollTop() > scrollHeight) {
      $(".pcTop #gotoTop").fadeIn();
    } else {
      $(".pcTop #gotoTop").fadeOut();
    }
  });

  /**
   * 回到顶部
   */
  $(".pcTop #gotoTop").click(function () {
    $("html ,body").animate(
      {
        scrollTop: 0,
      },
      300
    );
    return false;
  });

  /**
   * 小码哥智能客服
   */
  $(".pcTop #gpt").click(function () {
    $(".pcTop #gptModal").show();
  });

  $(".pcTop #gptModal .closeBtn").click(function (e) {
    e.stopPropagation();
    $(".pcTop #gptModal").hide();
  });

  // 移动端回到顶部
  $("#xiaomage-help-entry-mobile #gotoTop").hide(); //隐藏go to top按钮
  $(window).scroll(function () {
    var scrollHeight = $(document).height() * 0.02;
    if ($(this).scrollTop() > scrollHeight) {
      $("#xiaomage-help-entry-mobile #gotoTop").fadeIn();
    } else {
      $("#xiaomage-help-entry-mobile #gotoTop").fadeOut();
    }
  });

  /**
   * 回到顶部
   */
  $("#xiaomage-help-entry-mobile #gotoTop").click(function () {
    $("html ,body").animate(
      {
        scrollTop: 0,
      },
      300
    );
    return false;
  });

  $("#qqDialogMobile").on("click touchend", function () {
    // window.open('mqqwpa://im/chat?chat_type=wpa&uin=2410542817&version=1&src_type=web&web_src=oicqzone.com')
    window.open(
      "http://wpa.qq.com/msgrd?v=3&uin=2410542817&site=baidu.com&menu=yes"
    );
  });
  $("#xiaomage-help-entry-mobile .panel-close").on(
    "click touchend",
    function () {
      $("#xiaomage-help-entry-mobile .xiaomage-panel").removeClass("panelShow");
    }
  );
  $("#xiaomage-help-entry-mobile .xiaomage-entry-button").on(
    "click touchend",
    function () {
      setTimeout(function () {
        $("#xiaomage-help-entry-mobile .xiaomage-panel").addClass("panelShow");
      }, 200);
    }
  );
  //商桥链接跳转
  $(".shangqiao").on("click", function () {
    // if ($("#nb_invite_ok").length > 0) {
    // alert("sdfsfsdfsd");
    // $("#newBridge").show();
    // $("#nb_invite_ok").click();
    // }
    // window.open(
    //   "https://p.qiao.baidu.com/cps5/chatIndex?siteToken=3d49d3840e69d771b002185ab08a3c25&speedLogId=166996780672711d2_1669967806727_05605&reqParam=%7B%22from%22%3A1,%22sessionid%22%3A%22-100%22,%22siteId%22%3A%2210120001%22,%22tid%22%3A%22-1%22,%22userId%22%3A%226356299%22,%22ttype%22%3A1,%22siteConfig%22%3A%7B%22eid%22%3A%226356299%22,%22queuing%22%3A%22%22,%22isCsOnline%22%3A0,%22siteToken%22%3A%223d49d3840e69d771b002185ab08a3c25%22,%22userId%22%3A%226356299%22,%22isGray%22%3A%22false%22,%22vstProto%22%3A1,%22likeVersion%22%3A%22generic%22,%22siteId%22%3A%2210120001%22,%22online%22%3A%22false%22,%22startTime%22%3A1669967806452,%22webRoot%22%3A%22https%3A%2F%2Fp.qiao.baidu.com%2Fcps5%2F%22,%22bid%22%3A%22166961478760830768%22,%22isSmallFlow%22%3A0,%22isPreonline%22%3A0,%22userCommonSwitch%22%3A%7B%22isOpenTelCall%22%3Afalse,%22isOpenCallDialog%22%3Afalse,%22isOpenStateOfRead%22%3Afalse,%22isOpenVisitorLeavingClue%22%3Atrue,%22isOpenVoiceMsg%22%3Atrue,%22isOpenVoiceCom%22%3Atrue%7D,%22invited%22%3A0,%22origin%22%3A%22%E8%B6%85%E7%BA%A7%E7%A0%81%E6%95%B0%E5%AD%97%E8%BA%AB%E4%BB%BDSaaS%E4%BA%91%E5%B9%B3%E5%8F%B0%22%7D,%22config%22%3A%7B%22themeColor%22%3A%22F84048%22%7D%7D&hotIssue=undefined"
    // );
    window.open(
      "https://p.qiao.baidu.com/cps/chat?siteId=18636472&userId=35332037&siteToken=3c087a20849e8dd077ff2cbaf67809b7"
    );
  });
});
